import { FieldType } from "@/enums";
import { IFile } from "@/interfaces";
import { v4 } from "uuid";

interface IAttachment {
  name: string;
  url: string;
  contentType: string;
}

export const getFiles = (
  fieldValue: IAttachment | Array<IAttachment>,
  fieldType: string
): Array<IFile> => {
  const createFile = ({ name, url, contentType }: IAttachment): IFile => ({
    uid: v4(),
    name,
    url: `projects/${url.substring(0, url.lastIndexOf("/"))}`,
    blobUrl: url,
    imageUrl: contentType?.startsWith("image/") && url,
    type: contentType,
  });

  if (!fieldValue || (Array.isArray(fieldValue) && !fieldValue.length))
    return [];

  const isValidMultiAttachment =
    fieldType === FieldType.MultiAttachment &&
    Array.isArray(fieldValue) &&
    fieldValue.length;

  return isValidMultiAttachment
    ? fieldValue.map((existingAttachment) => createFile(existingAttachment))
    : [createFile(fieldValue as IAttachment)];
};
